
export default function lang(state = {}, action) {
    switch (action.type) {
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/lang/lang.js